/**
 * @fileoverview Data source for the student "My tasks" module, backed by the
 * legacy student-safe endpoints (see service/realSource).
 */

import { realSource } from './service/realSource'

export const dataSource = realSource
